<template>
  <!-- <v-container> -->

  <v-dialog max-width="500" fullscreen :overlay="false" v-model="myDialog">
    <template v-slot:activator="{ attrs }">
      <!-- v-on="on" -->
      <v-btn
        small
        class="d-print-none"
        color="success"
        v-bind="attrs"
        :loading="isloading"
        @click="OpenPrint"
        icon
      >
        <v-icon>fas fa-eye</v-icon>
      </v-btn>
    </template>
    <v-card>
      <div id="PrintPage" class="myContainer">
        <div class="d-print-none titleBar">
          <div>
            <v-btn
              icon
              class="d-print-none"
              @click="PrintPage"
              small
              color="white"
            >
              <v-icon>fas fa-print</v-icon>
            </v-btn>
          </div>
          <div>
            <v-btn
              class="d-print-none mr-5"
              @click="myDialog = false"
              small
              color="red white--text"
              >close
              <!-- <v-icon>fas fa-print</v-icon> -->
            </v-btn>
          </div>
        </div>
        <div class="PrintHeadTitle">
          <div class="title">
            <h5>{{ UsersToken.UserBranch }}</h5>
            <h5>{{ UsersToken.phone }}</h5>
            <h5>{{ `${UsersToken.country}-${UsersToken.City}` }}</h5>
          </div>
        </div>
        <div class="PrintHeadTitle">
          <div class="Headerinfo">
            <div id="clientInf">
              <div class="myTitle">ORDER:</div>
              <div class="myContent">{{ SaleOrder.Details }}</div>
            </div>
            <div id="clientInf">
              <div class="myTitle">DATE:</div>
              <div class="myContent">{{ SaleOrder.date }}</div>
            </div>
          </div>
          <div class="Headerinfo">
            <div id="clientInf">
              <div class="myTitle">CLIENT:</div>
              <div class="myContent">{{ SaleOrder.Name }}</div>
            </div>
            <div id="clientInf">
              <div class="myTitle">PHONE:</div>
              <div class="myContent">{{ SaleOrder.phone }}</div>
            </div>
            <!-- <h5>{{ client }}</h5> -->
          </div>
          <div class="Headerinfo">
            <div id="clientInf">
              <div class="myTitle">TOTAL:</div>
              <div class="myContent">
                {{ totalPrice.toLocaleString() }}
                <span>{{ UsersToken.CashBase | MoneySigns }}</span>
              </div>
            </div>

            <div id="clientInf">
              <div class="myTitle">Discount:</div>
              <div class="myContent">
                {{
                  client.Discount
                    ? client.Discount.toLocaleString()
                    : client.Discount
                }}
                <span>{{ UsersToken.CashBase | MoneySigns }}</span>
              </div>
            </div>
            <div id="clientInf">
              <div class="myTitle">PAID:</div>
              <div class="myContent">
                {{
                  client.Amount ? client.Amount.toLocaleString() : client.Amount
                }}
                <span>{{ UsersToken.CashBase | MoneySigns }}</span>
              </div>
            </div>
            <div id="clientInf">
              <div class="myTitle">BALANCE:</div>
              <div class="myContent">
                {{
                  client.Remain ? client.Remain.toLocaleString() : client.Remain
                }}
                <span>{{ UsersToken.CashBase | MoneySigns }}</span>
              </div>
            </div>
          </div>
        </div>
        <BasePureTable
          key="PrintTable"
          :myStyle="TableStyle"
          :headers="headers"
          :items="RunningTotal"
        >
          <template #[`coll.QTY`]="{row}">
            {{ row | SellTypeQty }}
          </template>

          <template #[`coll.Price`]="{row}">
            {{ row | SellTypePrice }}
          </template>
          <template #[`coll.Total`]="{row}">
            <!-- {{ row }} -->
            <span v-if="row.SellType === 'retail'">
              {{
                Math.abs(
                  row.price * Math.round(row.qty * row.UnitQty)
                ).toLocaleString()
              }}
            </span>
            <span v-else>
              {{ Math.abs(row.price * row.qty).toLocaleString() }}
            </span>
          </template>
          <template #tableFoot>
            <td></td>
            <td>{{ totalQty.toLocaleString() + " PCS" }}</td>
            <td></td>
            <td>
              {{ totalPrice.toLocaleString() }}
              <span>{{ UsersToken.CashBase | MoneySigns }}</span>
            </td>
            <td></td>
          </template>
        </BasePureTable>
      </div>
    </v-card>
  </v-dialog>
  <!-- </v-container> -->
</template>
<script>
import { Printd } from "printd";

import { TableCSS } from "../princssModule";
import { mapGetters } from "vuex";

export default {
  props: {
    PrintUrl: { type: String, default: () => "/Reports/sales/print" },
    SaleOrder: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isloading: false,
      myDialog: false,
      items: [],
      Entry: [],

      TableStyle: {
        headStyle: {
          "my-table-border": true,
          "my-table-content-centen": false,
          //   yellow: true
        },
        bodyStyle: {
          "my-table-border": true,
          "my-table-content-centen": false,
        },
      },
      //   dialog: false,
      headers: [
        {
          text: "Item",
          align: "left",
          value: "InvName",
          class: "green darken-3 white--text",
        },
        {
          text: "QTY",
          value: "qty",
          class: "green darken-3 white--text",
        },

        {
          text: "Price",
          value: "price",
          class: "green darken-3 white--text",
        },
        {
          text: "Total",
          value: "total",
          class: "green darken-3 white--text",
        },
        {
          text: "Balance",
          value: "balance",
          class: "green darken-3 white--text",
        },
      ],
    };
  },
  filters: {
    SellTypePrice(item) {
      // if (item.SellType == "retail")
      //   return (item.price / item.UnitQty).toFixed(1).toLocaleString();
      return item.price.toLocaleString();
      // return Math.abs(item.price / item.qty).toLocaleString();
    },
    SellTypeQty(row) {
      let qty = Math.abs(row.qty);
      const PCSQTY = Math.round((qty * row.UnitQty) % row.UnitQty);
      const BOXQTY = parseInt(qty);
      let FormatQTY = `0-${row.UnitType} `;
      if (BOXQTY > 0) FormatQTY = `${BOXQTY}-${row.UnitType} `;
      if (PCSQTY > 0) FormatQTY += `${PCSQTY}-PCS`;
      FormatQTY += ` =>(${Math.round(qty * row.UnitQty)} PCS)`;
      return FormatQTY;
    },
  },
  computed: {
    ...mapGetters(["UsersToken"]),
    PaidAmount() {
      return this.SaleOrder.Amount - this.client.Discount - this.client.Remain;
    },
    RunningTotal() {
      let myTotal = 0;
      // console.log(this.GroupedItems);
      return this.GroupedItems.map(trn => {
        let balance = Math.abs(trn.price * trn.qty);
        if (trn.SellType == "retail") {
          balance = Math.abs(Math.round(trn.UnitQty * trn.qty) * trn.price);
        }

        myTotal += balance;

        return { ...trn, balance: myTotal.toLocaleString() };
      });
    },
    client() {
      if (!this.Entry.length) return { Amount: 0, Discount: 0, Remain: 0 };
      return {
        Amount: this.Entry.reduce((t, { Amount, AccountName }) => {
          if (
            AccountName === "Mobel" ||
            AccountName === "Cash" ||
            AccountName === "Main Bank"
          )
            return (t += Amount);
          return t;
        }, 0),
        Discount: this.Entry.reduce((t, { Amount, AccountName }) => {
          if (AccountName === "Sales Discount") return (t += Amount);
          return t;
        }, 0),
        Remain: this.Entry.reduce((t, { Amount, AccountName }) => {
          if (AccountName === "Sales Receivable") return (t += Amount);
          return t;
        }, 0),
      };
    },

    totalPrice() {
      return this.items.reduce((t, { price, qty, SellType, UnitQty }) => {
        qty = Math.abs(qty);
        // console.log(qty);
        if (SellType == "retail") qty = UnitQty * qty;
        // console.log();
        return (t += parseFloat((price * qty).toFixed(1)));
      }, 0);
    },
    totalQty() {
      return this.items.reduce((t, { qty, UnitQty }) => {
        qty = Math.abs(qty * UnitQty);
        // if (SellType == "retail") qty = qty * UnitQty;
        return (t += qty);
      }, 0);
    },

    GroupedItems() {
      if (this.items && this.items.length) {
        const groupObj = this.items.reduce((result, item) => {
          const { code, ...restItem } = item;
          let { qty, codes } = result[item._id] || {
            qty: 0.0,
            codes: [],
          };
          result[item._id] = {
            ...restItem,
            qty: parseFloat((qty + item.qty).toFixed(5)),
            codes: [...codes, { code, qty: item.qty }],
          };
          return result;
        }, {});
        // console.log(groupObj);
        return Object.keys(groupObj).map(key => {
          return { ...groupObj[key] };
        });
      }
      return [];
    },
  },
  methods: {
    GetReq(query = null) {
      // console.log(this.SaleOrder);
      if (!query) {
        query = {
          OrderCode: this.SaleOrder.Details,
          Description: this.SaleOrder.Description,
          Ref: this.SaleOrder.Ref,
        };
      }
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.PrintUrl,
        query,
      });
    },
    OpenPrint() {
      //   console.log(this.UsersToken);
      this.items = [];
      this.Entry = [];
      this.isloading = true;
      this.GetReq()
        .then(val => {
          const { Entry, items } = val.data;
          // console.log(items);
          this.items = items;
          this.Entry = Entry;

          this.myDialog = true;
          this.isloading = false;
          // console.log(Entry);
        })
        .catch(() => {
          this.isloading = false;
        });
      //   this.myDialog = true;
    },
    PrintPage() {
      const myStyle = [TableCSS];
      const d = new Printd();
      d.print(document.getElementById("PrintPage"), myStyle);
    },
  },
};
</script>
<style scoped>
#PrintPage {
  /* padding: 10px 15px; */
  height: 100%;
  flex-direction: column;
  background-color: white;
  font-family: Calibri, "Courier New", Courier, monospace;
}
.myContainer {
  display: flex;
}

.PrintHeadTitle {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;

  background-color: teal;
  border-radius: 20px 20px 0 0;
  border-bottom: 3px solid black;
  flex-wrap: wrap;
  /* justify-content: center; */
  align-self: center;
  width: 90%;
  color: black;
  align-items: center;
  text-align: center;
  padding: 10px;
  /* padding-bottom: 5px; */
}
.PrintHeadTitle .title {
  width: 90%;
  line-height: 20px;
}

.PrintHeadTitle .Headerinfo {
  display: flex;
  flex-direction: column;
  padding: 5px;
  margin-bottom: 5px;
  color: black;
  justify-content: center;
  /* max-width: 40%; */
  /* line-height: 18px; */
  /* padding-right: 10px; */
  /* padding-left: 10px; */
}
#clientInf {
  display: flex;
  flex-direction: row;
}
#clientInf .myTitle {
  /* font-weight: bold; */
  padding-right: 10px;
  flex-wrap: nowrap;
}
#clientInf .myContent {
  flex-wrap: wrap;
  font-weight: lighter;
  text-align: center;
}

.Headerinfo h3,
.Headerinfo h5 {
  line-height: 0.5cm;
  font-weight: bold;
}

.titleBar {
  display: flex;
  /* flex-direction: row-reverse; */
  justify-content: end;
  background-color: rgb(3, 3, 129);
  height: 40px;
  align-items: center;
  padding-right: 15px;
  width: 90%;
  align-self: center;
}
</style>
